import { IComponentOptions } from "angular";
import { MealLogEntryListController } from "./controller";

export const vsComponentName = "mealLogEntryListComponent";

export const mealLogEntryListComponentOptions: IComponentOptions = {
  template: require("!html-loader!./index.html").default,
  controller: MealLogEntryListController,
  controllerAs: "entryListController",
  bindings: {
    machine: "<",
  },
};
